import headerSSComponent from './headerSS.component';

let headerSSModule = angular.module('social-security.headerSS', [
])

  .component('headerSs', headerSSComponent)

  .name;

export default headerSSModule;



// WEBPACK FOOTER //
// ./client/app/social-security.module/features/socialSecurity/headerSS/headerSS.js